




























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ListItemComponent extends Vue {
  @Prop() readonly items!: any;
  @Prop() readonly emptyText!: string;

  toReadableTitle(item) {
    if (item.IsDeadline) {
      return `${this.$t("will expire in")} ${item.ExpirationDays} ${this.$t(
        "days"
      )}`;
    } else if (item.IsReturn) {
      if (item.Status === "Sample Documents") {
        return `${this.$t("returned for audit documents")}`;
      } else {
        return `${this.$t("returned for correction")}`;
      }
    } else if (item.IsNegotiation) {
      return `${this.$t("returned for negotiation")}`;
    } else if (item.IsDue) {
      if (item.ExpirationDays < 0)
        return `${this.$t("is overdue by")} ${Math.abs(item.ExpirationDays)} ${this.$t("days")}`;
      else return `${this.$t("is due by")} ${Math.abs(item.ExpirationDays)} ${this.$t("days")}`;
    } else if(item.Section == "Amendment") {
      return this.$t(`is ready for your action`);
    } else {
      return this.$t(`is ready for your review`);
    }
  }

  toLocalDate(value) {
    var date = new Date(value);
    return date.toDateString();
  }
}
